// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.architect-dashboard,
.md-dashboard {
  font-family: Inter;
}
.architect-dashboard .card,
.md-dashboard .card {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  padding: 10px 50px 10px 10px;
}
.architect-dashboard p,
.md-dashboard p {
  font-size: 14px;
  font-family: Karla;
  text-wrap: nowrap;
}
.architect-dashboard .card-title,
.md-dashboard .card-title {
  font-size: 16px;
  font-weight: 700;
  text-wrap: nowrap;
}
.architect-dashboard .card-main-content,
.md-dashboard .card-main-content {
  font-size: 40px;
  font-weight: 700;
  text-wrap: nowrap;
  line-height: 52px;
}
.architect-dashboard img,
.md-dashboard img {
  position: relative;
  width: 15px;
  /* margin-left: 4px; */
  padding: 3px 10px;
  box-sizing: content-box;
  border-radius: 20px;
}
.architect-dashboard .main,
.md-dashboard .main {
  position: relative;
  margin-bottom: 4rem;
}
@media (max-width: 1280px) {
  .architect-dashboard .main,
  .md-dashboard .main {
    width: 20% !important;
  }
}
@media (max-width: 900px) {
  .architect-dashboard .main,
  .md-dashboard .main {
    width: 50% !important;
  }
}
.architect-dashboard .upper-div,
.md-dashboard .upper-div {
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  z-index: 999;
  left: 0;
}
.architect-dashboard .lower-div,
.architect-dashboard .third-div,
.md-dashboard .lower-div,
.md-dashboard .third-div {
  width: 80%;
  height: 166px;
  color: #fff;
  margin-top: 0;
  transition: margin-top 0.3s ease, transform 0.3s ease;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0;
  margin-right: 12px;
  margin-left: 12px;
}
.architect-dashboard .lower-div .card-main-content,
.architect-dashboard .third-div .card-main-content,
.md-dashboard .lower-div .card-main-content,
.md-dashboard .third-div .card-main-content {
  color: white;
  font-size: 26px;
  text-wrap: nowrap;
}
.architect-dashboard .lower-div .card-body,
.architect-dashboard .third-div .card-body,
.md-dashboard .lower-div .card-body,
.md-dashboard .third-div .card-body {
  padding: 5px 20px;
}
.architect-dashboard .lower-div p,
.architect-dashboard .third-div p,
.md-dashboard .lower-div p,
.md-dashboard .third-div p {
  font-size: 12px;
}
.architect-dashboard .third-div .card-body,
.md-dashboard .third-div .card-body {
  color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
}
.architect-dashboard .lower-div,
.md-dashboard .lower-div {
  background-color: #7fb036;
}
.architect-dashboard .third-div,
.md-dashboard .third-div {
  background-color: #4f6b45;
}
.architect-dashboard .upper-div:hover,
.md-dashboard .upper-div:hover {
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);
  background-color: #45852e;
  color: white;
}
.architect-dashboard .upper-div:hover ~ .lower-div,
.md-dashboard .upper-div:hover ~ .lower-div {
  margin-top: -85px;
  transform: rotate(4deg);
}
.architect-dashboard .upper-div:hover ~ .third-div,
.md-dashboard .upper-div:hover ~ .third-div {
  margin-top: 75px;
  transform: rotate(-4deg);
}
.architect-dashboard .upper-div:hover .card-main-content,
.md-dashboard .upper-div:hover .card-main-content {
  color: white !important;
}
.architect-dashboard .upper-div:hover .btn,
.md-dashboard .upper-div:hover .btn {
  color: white;
  background-color: rgba(203, 203, 203, 0.1803921569);
}

.parents .dashboard_heading {
  color: #000;
  font-size: 44px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  /* 48.4px */
  letter-spacing: -0.88px;
}
.parents .design1 {
  border-radius: 16px;
  background-color: #b7cf53;
  box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);
}
.parents .design1 .obpas1 {
  color: #516900;
  font-weight: 500;
  font-size: 14px;
}
.parents .design1 .number1 {
  color: #516900;
}
.parents .design1 .status1 {
  color: #516900;
}
.parents .design1 .logo1,
.parents .design1 .logo2,
.parents .design1 .logo3 {
  width: 32px;
  height: 20px;
  border-radius: 36px;
  background: #869a6b;
}
.parents .design2 {
  border-radius: 16px;
  background-color: #80b036;
  box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);
}
.parents .design2 .obpas2 {
  color: #818831;
  font-weight: 500;
  font-size: 14px;
}
.parents .design2 .number2 {
  color: #818831;
}
.parents .design2 .status2 {
  color: #818831;
}
.parents .design2 .logo2 {
  width: 32px;
  height: 20px;
  border-radius: 36px;
  background: #a6ad68;
}
.parents .design3 {
  border-radius: 16px;
  background-color: #45852e;
  box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);
}
.parents .design3 .obpas3 {
  color: #45852e;
  font-weight: 500;
  font-size: 14px;
}
.parents .design3 .number3 {
  color: #45852e;
}
.parents .design3 .logo3 {
  width: 32px;
  height: 20px;
  border-radius: 36px;
  background: #7eab6e;
}

.scrutiny {
  border-radius: 12px;
  background: rgba(69, 133, 46, 0.84);
  box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);
}
.scrutiny .title {
  color: #fff;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
}
.scrutiny .logo {
  width: 32px;
  height: 20px;
  border-radius: 36px;
  background: #ebebeb;
}`, "",{"version":3,"sources":["webpack://./src/features/modules/UserManagement/ArchitectModule/ArchitectStyles.scss"],"names":[],"mappings":"AAIA;;EAEI,kBAAA;AAHJ;AAOI;;EAGI,0CAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;AANR;AASI;;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;AANR;AASI;;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AANR;AASI;;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AANR;AASI;;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EAEA,iBAAA;EACA,uBAAA;EACA,mBAAA;AAPR;AAUI;;EACI,kBAAA;EACA,mBAAA;AAPR;AAWI;EACI;;IACI,qBAAA;EARV;AACF;AAWI;EACI;;IACI,qBAAA;EARV;AACF;AAeI;;EACI,kBAAA;EACA,gBAAA;EACA,qDAAA;EACA,YAAA;EACA,OAAA;AAZR;AAeI;;;;EAGI,UAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAZR;AAcQ;;;;EACI,YAAA;EACA,eAAA;EACA,iBAAA;AATZ;AAYQ;;;;EACI,iBAAA;AAPZ;AAUQ;;;;EACI,eAAA;AALZ;AAUQ;;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAPZ;AAmBI;;EACI,yBAhIU;AAgHlB;AAmBI;;EACI,yBAnIQ;AAmHhB;AAkBI;;EACI,2CAAA;EACA,yBAzIQ;EA0IR,YAAA;AAfR;AAkBI;;EACI,iBAAA;EACA,uBAAA;AAfR;AAkBI;;EACI,gBAAA;EACA,wBAAA;AAfR;AAkBI;;EACI,uBAAA;AAfR;AAkBI;;EACI,YAAA;EACA,mDAAA;AAfR;;AAoBI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;AAjBR;AAoBI;EACI,mBAAA;EACA,yBAAA;EACA,oDAAA;AAlBR;AAoBQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAlBZ;AAqBQ;EACI,cAAA;AAnBZ;AAsBQ;EACI,cAAA;AApBZ;AAuBQ;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AArBZ;AAyBI;EACI,mBAAA;EACA,yBAAA;EACA,oDAAA;AAvBR;AAyBQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAvBZ;AA0BQ;EACI,cAAA;AAxBZ;AA2BQ;EACI,cAAA;AAzBZ;AA4BQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA1BZ;AA8BI;EACI,mBAAA;EACA,yBAAA;EACA,oDAAA;AA5BR;AA8BQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AA5BZ;AA+BQ;EACI,cAAA;AA7BZ;AAgCQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA9BZ;;AAmCA;EACI,mBAAA;EACA,mCAAA;EACA,oDAAA;AAhCJ;AAkCI;EACI,WAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;AAjCR;AAoCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAlCR","sourcesContent":["$primary-color: #45852e;\n$secondary-color: #7fb036;\n$ternary-color: #4f6b45;\n\n.architect-dashboard,\n.md-dashboard {\n    font-family: Inter;\n\n    // min-height: 100vh;\n    // overflow: hidden;\n    .card {\n        // width: 230px;\n        // height: 145px;\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);\n        border: none;\n        border-radius: 16px;\n        display: flex;\n        justify-content: center;\n        padding: 10px 50px 10px 10px;\n    }\n\n    p {\n        font-size: 14px;\n        font-family: Karla;\n        text-wrap: nowrap;\n    }\n\n    .card-title {\n        font-size: 16px;\n        font-weight: 700;\n        text-wrap: nowrap;\n    }\n\n    .card-main-content {\n        font-size: 40px;\n        font-weight: 700;\n        text-wrap: nowrap;\n        line-height: 52px;\n    }\n\n    img {\n        position: relative;\n        width: 15px;\n        /* margin-left: 4px; */\n        // background-color: #2b8080;\n        padding: 3px 10px;\n        box-sizing: content-box;\n        border-radius: 20px;\n    }\n\n    .main {\n        position: relative;\n        margin-bottom: 4rem;\n        // max-width: 190px;\n    }\n\n    @media (max-width: 1280px) {\n        .main {\n            width: 20% !important;\n        }\n    }\n\n    @media (max-width: 900px) {\n        .main {\n            width: 50% !important;\n        }\n    }\n\n    // .main:nth-child(4n) {\n    //   margin: 0;\n    // }\n\n    .upper-div {\n        position: relative;\n        overflow: hidden;\n        transition: transform 0.3s ease, box-shadow 0.3s ease;\n        z-index: 999;\n        left: 0;\n    }\n\n    .lower-div,\n    .third-div {\n        // z-index: 9999;\n        width: 80%;\n        height: 166px;\n        color: #fff;\n        margin-top: 0;\n        transition: margin-top 0.3s ease, transform 0.3s ease;\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 0;\n        margin-right: 12px;\n        margin-left: 12px;\n\n        .card-main-content {\n            color: white;\n            font-size: 26px;\n            text-wrap: nowrap;\n        }\n\n        .card-body {\n            padding: 5px 20px;\n        }\n\n        p {\n            font-size: 12px;\n        }\n    }\n\n    .third-div {\n        .card-body {\n            color: white;\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            justify-content: end;\n        }\n    }\n\n    // .lower-div {\n    //   background-color: $ternary-color;\n    // }\n\n    // .third-div {\n    //   background-color: $secondary-color;\n    // }\n\n    .lower-div {\n        background-color: $secondary-color;\n    }\n\n    .third-div {\n        background-color: $ternary-color;\n    }\n    .upper-div:hover {\n        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);\n        background-color: $primary-color;\n        color: white;\n    }\n\n    .upper-div:hover ~ .lower-div {\n        margin-top: -85px;\n        transform: rotate(4deg);\n    }\n\n    .upper-div:hover ~ .third-div {\n        margin-top: 75px;\n        transform: rotate(-4deg);\n    }\n\n    .upper-div:hover .card-main-content {\n        color: white !important;\n    }\n\n    .upper-div:hover .btn {\n        color: white;\n        background-color: #cbcbcb2e;\n    }\n}\n\n.parents {\n    .dashboard_heading {\n        color: #000;\n        font-size: 44px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 110%;\n        /* 48.4px */\n        letter-spacing: -0.88px;\n    }\n\n    .design1 {\n        border-radius: 16px;\n        background-color: #b7cf53;\n        box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);\n\n        .obpas1 {\n            color: #516900;\n            font-weight: 500;\n            font-size: 14px;\n        }\n\n        .number1 {\n            color: #516900;\n        }\n\n        .status1 {\n            color: #516900;\n        }\n\n        .logo1,\n        .logo2,\n        .logo3 {\n            width: 32px;\n            height: 20px;\n            border-radius: 36px;\n            background: #869a6b;\n        }\n    }\n\n    .design2 {\n        border-radius: 16px;\n        background-color: #80b036;\n        box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);\n\n        .obpas2 {\n            color: #818831;\n            font-weight: 500;\n            font-size: 14px;\n        }\n\n        .number2 {\n            color: #818831;\n        }\n\n        .status2 {\n            color: #818831;\n        }\n\n        .logo2 {\n            width: 32px;\n            height: 20px;\n            border-radius: 36px;\n            background: #a6ad68;\n        }\n    }\n\n    .design3 {\n        border-radius: 16px;\n        background-color: #45852e;\n        box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);\n\n        .obpas3 {\n            color: #45852e;\n            font-weight: 500;\n            font-size: 14px;\n        }\n\n        .number3 {\n            color: #45852e;\n        }\n\n        .logo3 {\n            width: 32px;\n            height: 20px;\n            border-radius: 36px;\n            background: #7eab6e;\n        }\n    }\n}\n\n.scrutiny {\n    border-radius: 12px;\n    background: rgba(69, 133, 46, 0.84);\n    box-shadow: 0px 4px 54px 0px rgba(69, 133, 46, 0.06);\n\n    .title {\n        color: #fff;\n\n        font-family: Inter;\n        font-size: 20px;\n        font-weight: 600;\n    }\n\n    .logo {\n        width: 32px;\n        height: 20px;\n        border-radius: 36px;\n        background: #ebebeb;\n    }\n}\n\n// .card-main-content {\n//   color: white;\n//   font-size: 26px;\n// }\n\n// .lower-div,\n// .third-div {\n//   z-index: 9;\n//   width: 140px;\n//   color: #fff;\n//   margin-top: 0;\n//   transition: margin-top 0.3s ease, transform 0.3s ease;\n//   position: absolute;\n//   right: 0;\n//   top: 0;\n// }\n\n// .upper-div:hover~.lower-div {\n//   margin-top: -75px;\n//   transform: rotate(4deg);\n// }\n\n// .upper-div:hover~.third-div {\n//   margin-top: 75px;\n//   transform: rotate(-4deg);\n// }\n\n// .upper-div:hover .card-main-content {\n//   color: white;\n// }\n\n// .upper-div:hover .btn {\n//   color: white;\n//   background-color: #cbcbcb2e;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
